import { createAction } from 'redux-actions';

export const openErrorModal = createAction('OPEN_ERROR_MODAL');
export const closeErrorModal = createAction('CLOSE_ERROR_MODAL');



// WEBPACK FOOTER //
// ./src/components/Errors/actions.js